module.exports = __webpack_public_path__ + "img/LightBlack.630a884d.svg";